import React from "react";
import Hero from "../components/Hero";

const Home = ({ setRps }) => {
  return (
    <>
      <Hero setRps={setRps} />
    </>
  );
};

export default Home;
